import { useEffect, useState, useCallback } from 'react'
import { Grid, TextField, Typography, CircularProgress } from '@material-ui/core'
import useStyles from './styles'
import { Autocomplete } from '@material-ui/lab'
import { SelecionarData } from 'components/SelecionarData'
import { useUsuarioService } from 'hooks/useUsuarioService'


export const FormDescartarVestigio = (props) => {
	const { form, handleChange, user, multiple, setor } = props
	const classes = useStyles()
	const usuarioService = useUsuarioService()
	const [usuarios, setUsuarios] = useState([])
	const [processandoUsuarios, setProcessandoUsuarios] = useState(false)
	const fetchUsuarios = useCallback(async () => {
		setProcessandoUsuarios(true)
		const response = await usuarioService.listarUsuarios()
		setUsuarios(response)
		setProcessandoUsuarios(false)
	}, [])

	useEffect(() => {
	fetchUsuarios()
	}, [fetchUsuarios])
	return (
		<Grid container className={classes.container} spacing={3}>
			<Grid item md={12} sm={12} xs={12} lg={12}>
				<Typography className={classes.gridTitle}>FORMULÁRIO DE DESCARTE DE VESTÍGIO</Typography>
			</Grid>

			{processandoUsuarios ? (
			<div className={classes.carregando}>
				<CircularProgress disableShrink />
			</div>
			) : (
			<Grid item container spacing={2}>
				<Grid item xs={12} >
					<Autocomplete
						name="autorizacaousuario"
						noOptionsText="Sem informações"
						value={form.usuAutorizacao}
						options={usuarios}
						onChange={(event, newValue) => {
							handleChange('usuAutorizacao', newValue)
						}}
						getOptionSelected={(option, value) => option.id === value?.id}
						getOptionLabel={(option) => `${option.nome || ''}${option.cargo?.nome ? ` - ${option.cargo.nome.toUpperCase()}` : ''}`}
						renderOption={(option) => `${option.nome || ''}${option.cargo?.nome ? ` - ${option.cargo.nome.toUpperCase()}` : ''}`}
						renderInput={(params) => (
						<TextField
							{...params}
							variant="outlined"
							label="Autorizado por"
							required
							InputLabelProps={{
							shrink: true,
							}}
						/>
						)}
					/>
				</Grid>
				<Grid item md={6} sm={6} xs={12}>
					<TextField
						fullWidth
						label="Número do documento"
						name="numDocumento"
						onChange={(event) => {
							handleChange('numDocumento', event.target.value)
						}}
						value={form.numDocumento || ''}
						variant="outlined"
						InputLabelProps={{
						shrink: true,
						}}
						required
					/>
					<Typography variant="caption" style={{ display: 'block', marginTop: '4px' }}>
						Caracteres restantes: {250 - (form.numDocumento?.length || 0)}
					</Typography>
				</Grid>

				<Grid item md={6} sm={6} xs={12}>
					<SelecionarData
						dataBD={form.data}
						callback={(date) => {
						handleChange('data', date)
						}}
						label="Data da autorização"
						required
					/>
				</Grid>

				<Grid item md={12} sm={12} xs={12}>
					<TextField
						fullWidth
						label="Observações"
						name="observacao"
						onChange={(event) => {
							handleChange('observacao', event.target.value)
						}}
						value={form.observacao || ''}
						multiline
						variant="outlined"
						InputLabelProps={{
						shrink: true,
						}}
					/>
					<Typography variant="caption" className={classes.caracteresRestantes}>
						Caracteres restantes: {250 - (form.observacao?.length || 0)}
					</Typography>
				</Grid>
			</Grid>
			)}
		</Grid>
	)
}